import { Breadcrumb, Pagination } from "@components/anti"
import Layout from "@components/layout"
import React, { useEffect, useState } from "react"
import Helmet from "react-helmet"
import Seo from "components/seo"
import CardProduct from "components/global/card-product/card-product"
import { useScrollAnim } from "@components/hooks/hooks"
import { F_Q_CATALOGS_CATEGORY, sendDataLayer } from "lib/function"
import { useRouter } from "next/router"
import { showOption } from "lib/utils/constant"
import InfiniteScroll from "react-infinite-scroll-component"
import icoBlank from "assets/img/icon/ico_add-cart-light.svg"
import BlankState from "@components/pages/wishlist/blank-state"

export default function SalePage({
  data,
  pagination,
  locale,
  limit,
  sort,
  token,
}) {
  const [trigger, anim] = useScrollAnim([0.0125, 0.5, 0.75])
  const Router = useRouter()
  const [state, setState] = useState({
    sort: sort ?? "order_weight-asc",
    show: limit ?? "",
    page: 2,
  })
  const [dataFilter, setDataFilter] = useState(data)

  const handleChangePage = (val) => {
    Router.query.page = val
    Router.push(Router)
  }

  useEffect(() => {
    const main = document.querySelector(".bd-search-result main")
    main?.classList?.remove("fadeOut")
    main?.classList?.add("fadeIn")

    setDataFilter(data)
  }, [data])

  useEffect(() => {
    const { sort, limit, page } = Router.query
    setState((prev) => ({
      ...prev,
      sort: sort ?? "order_weight-asc",
      show: limit ?? "",
      page: page ?? 2,
    }))
  }, [Router.query.slug])

  const handleChangeShow = (e) => {
    setState((prev) => ({ ...prev, show: e.target.value, page: 2 }))
    if (e.target.value === "") {
      delete Router.query.limit
    } else {
      Router.query.limit = e.target.value
    }
    delete Router.query.page
    Router.push(Router)
  }

  const getData = async () => {
    let newCatalogs = await F_Q_CATALOGS_CATEGORY(
      {
        lang: locale,
        page: state.page,
        limit: 10,
        sort: state.sort,
        sale: 1,
      },
      token
    )
    setState((prev) => ({ ...prev, page: prev.page + 1 }))
    setDataFilter((prev) => [...prev, ...newCatalogs.data?.catalogs?.products])
  }

  // For Datalayer ************************************************************
  const [hasSent, setHasSent] = useState(false)
  useEffect(() => {
    if (hasSent) {
      setHasSent(false)
    }
  }, [Router.asPath])
  useEffect(() => {
    if (!hasSent) {
      sendDataLayer({
        event: "view_category",
        category_name: "SALE Items",
        subcategory_name: "",
      })
      setHasSent(true)
    }
  }, [Router.asPath])
  // For Datalayer ************************************************************

  return (
    <>
      <Seo title="New Product" />
      <Helmet>
        <body className="bd-search-result" />
      </Helmet>
      <Layout>
        {dataFilter?.length > 0 ? (
          <section className="sc-product-category">
            <div className="container">
              <div className="btn-back-wrapper">
                <span
                  className="ail ai-arrow-left font-weight-bold"
                  style={{ cursor: "pointer" }}
                  onClick={() => Router.back()}
                />
              </div>
              <Breadcrumb path={`/Sale`} className="d-none d-sm-flex" />
              <div className="product-category">
                <div className="sort-wrapper">
                  <h5 className="title">
                    {locale === "id" ? "Produk Diskon" : "SALE Items"}
                  </h5>
                  <div className="sort-content-wrapper">
                    <div className="wrapper-select">
                      <h6 className="label-select">
                        {locale === "id" ? "Lihat" : "Show"}:
                      </h6>
                      <div className="wrapper-field-select">
                        <select
                          value={state.show}
                          onChange={handleChangeShow}
                          className="custom-select-category"
                        >
                          {showOption(locale).map(({ label, value }, i) => (
                            <option value={value} key={i}>
                              {label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                {state.show === "" ? (
                  <InfiniteScroll
                    dataLength={dataFilter?.length}
                    next={getData}
                    hasMore={state.page <= pagination.last_page}
                    loader={
                      <div className="text-center py-5">
                        <h6>Loading....</h6>
                      </div>
                    }
                    scrollThreshold="1000px"
                  >
                    <div className="card-product-list" ref={trigger}>
                      {dataFilter.map((item, i) => (
                        <div
                          key={i}
                          className={`card-product-item ${anim((i + 1) % 10)}`}
                        >
                          <CardProduct
                            {...item}
                            imgAlt={`sale-product-${i}`}
                            noCategory
                            listName={"SALE Items"}
                            index={i + 1}
                          />
                        </div>
                      ))}
                    </div>
                  </InfiniteScroll>
                ) : (
                  <div className="card-product-list" ref={trigger}>
                    {dataFilter.map((item, i) => (
                      <div
                        key={i}
                        className={`card-product-item ${anim(i + 1)}`}
                      >
                        <CardProduct
                          {...item}
                          imgAlt={`sale-product-${i}`}
                          noCategory
                          listName={"SALE Items"}
                          index={i + 1}
                        />
                      </div>
                    ))}
                  </div>
                )}
                {pagination?.total_data > 0 && state.show && (
                  <div className="d-flex justify-content-end">
                    <Pagination
                      count={pagination.last_page}
                      onChange={handleChangePage}
                      page={pagination.current_page}
                    />
                  </div>
                )}
              </div>
            </div>
          </section>
        ) : (
          <div className="pt-4">
            <BlankState
              title={
                locale === "id"
                  ? "Produk tidak ditemukan"
                  : "Products not found"
              }
              icon={icoBlank}
            />
          </div>
        )}
      </Layout>
    </>
  )
}

export const getServerSideProps = async (ctx) => {
  const token = `${process.env.INIT_TOKEN}`
  let { page, sort, limit } = ctx.query
  let { locale } = ctx

  try {
    let newCatalogs = await F_Q_CATALOGS_CATEGORY(
      {
        lang: locale,
        page: page ?? 1,
        limit: limit ?? 10,
        sort: sort ?? "order_weight-asc",
        sale: 1,
      },
      token
    )

    let data = newCatalogs.data?.catalogs?.products ?? []
    let pagination = newCatalogs.data?.catalogs?.pagination

    return {
      props: {
        data,
        pagination,
        locale,
        limit: limit ?? "",
        sort: sort ?? "order_weight-asc",
        token,
      },
    }
  } catch (error) {
    return { notFound: true }
  }
}
